export default __webpack_public_path__ + "static/media/product-image.42763eb9.jpg";